import { teamEventsForMetricAtom, teamEventsForMetricCountAtom } from '@/atoms/queries/team/teamEventData';
import { MetricKeyFallbackWrapper } from '@/components/metric/MetricKeyFallbackWrapper';
import { EventsTableBase, EventsTableWithPagination } from '@/components/tables/EventsTable';

export const TeamVisEventsTable = () => (
  <MetricKeyFallbackWrapper fallback={<EventsTableBase isLoading />}>
    <EventsTableWithPagination eventsAtom={teamEventsForMetricAtom} dataLengthAtom={teamEventsForMetricCountAtom} />
  </MetricKeyFallbackWrapper>
);
